import styled from 'styled-components';

export const DashboardContainer = styled.div`
  .ant-layout {
    background: #f5f5f5;
  }
`;

export const SidebarContent = styled.div`
  padding: 20px 0;
`;

export const Logo = styled.div`
  padding: 0 24px;
  margin-bottom: 20px;
  
  h2 {
    color: #1890ff;
    margin: 0;
    font-weight: 600;
    font-size: 20px;
  }
`;

export const MainContent = styled.div`
  padding: 24px;
  background: #fff;
  margin: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-height: calc(100vh - 48px);
`;
